import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from './components/LoadingOverlay';
import { apiRequest, graphRequest } from './redux/authConfig';
import MainAuthenticated from './containers/MainAuthenticated';
import AppMessage from './containers/AppMessage';
import {
  AuthenticatedTemplate,
  useAccount,
  useMsal,
  useMsalAuthentication,
} from '@azure/msal-react';
import { setMessage } from './redux/message';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const App = () => {
  const isLoadingData = useSelector((state) => state.api.isLoadingData);
  const { error } = useMsalAuthentication('redirect');
  if (error) {
    const dispatch = useDispatch();
    dispatch(setMessage(error));
  }
  return (
    <div>
      <AuthenticatedTemplate>
        <AuthenticatedApp />
      </AuthenticatedTemplate>
      {isLoadingData && <LoadingOverlay />}
      <AppMessage />
    </div>
  );
};

const AuthenticatedApp = () => {
  const [tokenReady, setTokenReady] = useState();
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0]);
  const getToken = () => {
    try {
      instance
        .acquireTokenSilent({
          ...apiRequest,
          account: account,
        })
        .then((response) => {
          localStorage.setItem('access-token', response.accessToken);
          setTokenReady(true);
          setTimeout(() => {
            getToken();
          }, 600000);
        })
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenRedirect({ ...apiRequest, account: account })
              .then((response) => {
                localStorage.setItem('access-token', response.accessToken);
                setTokenReady(true);
                setTimeout(() => {
                  getToken();
                }, 600000);
              })
              .catch((err2) => {
                console.log('Authentication failure', err2);
              });
          }
        });
      instance
        .acquireTokenSilent({
          ...graphRequest,
          account: account,
        })
        .then((response) => {
          localStorage.setItem('graph-access-token', response.accessToken);
        })
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenRedirect({ ...graphRequest, account: account })
              .then((response) => {
                localStorage.setItem('graph-access-token', response.accessToken);
              })
              .catch((err2) => {
                console.log('Authentication failure3', err2);
              });
          }
        });
    } catch (e) {
      console.log('auth error', e);
    }
  };
  useEffect(() => {
    if (account) {
      getToken();
    }
  }, [account, instance]);
  return <>{tokenReady && <MainAuthenticated />}</>;
};

export default App;
